import * as cl from "classnames"
import * as React from "react"
import * as Model from "../../../../../model"
import { getBudgets } from "../../../../../service/sfp/berger-levrault-ws-service"

export default class BudgetField extends React.Component<Props, State> {
	static id = "local-authority-detail-bl-budget"
	private abortController = new AbortController()

	constructor(props: Readonly<Props>) {
		super(props)
		this.state = {
			budgets: [],
			error: null,
			fetchingBudgets: false
		}
	}

	componentDidMount() {
		if (this.props.idCollectivite) this.forceFetchingBudgets()
	}

	componentWillReceiveProps(nextProps: Readonly<Props>): void {
		if (!nextProps.idCollectivite) return this.setState({ budgets: [] })

		if (nextProps.idCollectivite !== this.props.idCollectivite)
			return this.forceFetchingBudgets()
	}

	componentWillUnmount(): void {
		this.abortController.abort()
	}

	render() {
		const loading = this.props.loading || this.state.fetchingBudgets
		const disabled = loading || !this.state.budgets.length

		return <div className="field">
			<label className="label" htmlFor={BudgetField.id}>
				Budget de gestion financière
			</label>

			<span className="control">
				<span className={cl("select is-fullwidth", { "is-loading": loading, "is-danger": this.state.error })}>
					<select
					disabled={disabled}
					id={BudgetField.id}
					required
					value={this.props.value || ""}
					onChange={e => this.handleChange(e)}>
						{this.renderBudgetsOptions()}
					</select>
				</span>
			</span>

			{this.state.error &&
			<p className="help is-danger">
				{this.state.error.message}&nbsp;{this.state.error.detail}
			</p>}
		</div>
	}

	private forceFetchingBudgets(): void {
		this.abortController.abort()
		this.abortController = new AbortController

		this.setState({ fetchingBudgets: true }, () => {
			getBudgets(
				this.props.serverAddress,
				this.props.serverPort,
				this.props.idCollectivite,
				this.abortController.signal
			)
			.then(budgets => {
				budgets.sort((b1, b2) => b1.codeBudget > b2.codeBudget ? 1 : -1)
				this.setState({
					budgets,
					error: null,
					fetchingBudgets: false
				})
			})
			.catch(reason => {
				this.setState({
					budgets: [],
					error: {
						detail: reason instanceof Error ? reason.message : String(reason),
						message: "Impossible d'obtenir les budgets de gestion financière."
					},
					fetchingBudgets: false
				})
			})
		})
	}

	private handleChange(e: React.ChangeEvent<HTMLSelectElement>): void {
		const value = parseInt(e.target.value)
		this.props.onChange(value !== NaN ? value : null)
	}

	private renderBudgetsOptions(): React.ReactNode {
		if (this.props.loading) return <option value="">Chargement...</option>

		if (!this.state.budgets.length)
			return <option value="">
				Aucun budget de gestion financière disponible
			</option>

		const helpTitle = "Sélectionner un budget de gestion financière"

		const helpOption = <option disabled key={-1} title={helpTitle} value="">
			{helpTitle}
		</option>

		const options = this.state.budgets.map((b, i) => {
			const label = `${b.codeBudget} - ${b.nomBudget}`
			return <option key={i} title={label} value={b.idBudgetGF}>
				{label}
			</option>
		})

		return [helpOption, ...options]
	}
}

interface Props {
	idCollectivite: number | null;
	loading: boolean;
	serverAddress: string;
	serverPort: number;
	value: number | null;
	onChange(value: number | null): void;
}

interface State {
	budgets: Model.Budget[];
	error: { message: string, detail: string } | null;
	fetchingBudgets: boolean;
}



// WEBPACK FOOTER //
// ./src/component/page/local-authority-detail-page/connector-field/berger-levrault-connector/budget-field.tsx